const populateFormFields = ({ setValue, selectedTarget }) => {
  const data = selectedTarget?.rawData;

  setValue('appliedAt', new Date(data?.appliedAt));
  setValue('brandId', { id: data?.brand?.id, label: data?.brand?.name, value: data?.brand?.name });
  setValue('targetGmv', data?.targetGmv);

  setValue('targetViewsShopee', `${data?.platformTargets[0]?.targetViews}`);
  setValue('targetCtrShopee', data?.platformTargets[0]?.targetCtr);
  setValue('targetCtorShopee', data?.platformTargets[0]?.targetCtor);
  setValue('targetAovShopee', data?.platformTargets[0]?.targetAov);
  setValue('targetViewsTiktok', `${data?.platformTargets[1]?.targetViews}`);
  setValue('targetCtrTiktok', data?.platformTargets[1]?.targetCtr);
  setValue('targetCtorTiktok', data?.platformTargets[1]?.targetCtor);
  setValue('targetAovTiktok', data?.platformTargets[1]?.targetAov);
  setValue('targetErrTiktok', data?.platformTargets[1]?.targetErr);
};

export default populateFormFields;
